import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        console.error('Core Logic Collision Detected:', error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            const errorStr = typeof this.state.error === 'object'
                ? (this.state.error.message || JSON.stringify(this.state.error))
                : String(this.state.error);

            return (
                <div style={{
                    display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                    height: '100vh', background: '#0a0a0c', color: '#ffffff', padding: '2rem', textAlign: 'center',
                    fontFamily: 'system-ui, -apple-system, sans-serif'
                }}>
                    <div style={{
                        background: 'rgba(99, 102, 241, 0.1)', width: '80px', height: '80px', borderRadius: '24px',
                        display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '2rem'
                    }}>
                        <span style={{ fontSize: '2rem', fontWeight: 900 }}>!</span>
                    </div>
                    <h2 style={{ fontSize: '2rem', marginBottom: '1rem', fontWeight: 900, color: '#f472b6' }}>SYSTEM INTEGRITY FAILURE</h2>
                    <div style={{
                        background: 'rgba(244, 114, 182, 0.05)', border: '1px solid rgba(244, 114, 182, 0.2)',
                        padding: '1.5rem', borderRadius: '16px', maxWidth: '600px', marginBottom: '2rem'
                    }}>
                        <p style={{ color: '#f472b6', fontWeight: 700, marginBottom: '0.5rem', fontSize: '0.9rem' }}>
                            A rendering collision (React Error 31 candidate) was intercepted in the core neural net.
                        </p>
                        <p style={{ fontSize: '0.75rem', opacity: 0.7, fontFamily: 'monospace', wordBreak: 'break-all' }}>
                            {errorStr}
                        </p>
                    </div>
                    <button
                        onClick={() => { localStorage.clear(); window.location.href = '/login'; }}
                        style={{
                            padding: '1rem 2rem', background: '#6366f1', color: 'white', border: 'none',
                            borderRadius: '12px', fontWeight: 800, cursor: 'pointer', boxShadow: '0 0 20px rgba(99, 102, 241, 0.4)'
                        }}
                    >
                        PURGE LOCAL CACHE & REBOOT
                    </button>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
